import styled from 'styled-components';
import { Title, Paragrafo, Sectionpd} from "../componentes/padroes";
import '../pages/home.css'
import CarroselClientes from '../componentes/carrosel';
import CarrosselMultiplo from '../componentes/conhecimentos';
import { Helmet } from 'react-helmet';
import JsonWindow from '../componentes/jsonwindows';
import BgBanner from '../componentes/bgbanner';

const Bannerao = styled.section`
    padding: 50px 0 0;
    background-color: #2A2A2A;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    @media (min-width: 996px) {
        padding: 40px 0 20px;
        min-height: 100vh;
    }

    &:before {
        content: "";
        inset: 0;
        position: absolute;
        background: linear-gradient(182deg,rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 1) 100%);
    }
`

const Certificadosbtn = styled.a`
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    color: #fff;
    text-decoration: none;
    transition: 0.5s linear;
    padding: 10px 0;
    & span{
        font-weight: 300;
        text-transform: uppercase;
    }
    & span b{
        font-weight: 600;
    }
    &:hover{
        color: #CD0FE8;
    }
    @media (min-width: 996px) {
        padding: 20px 0;
        flex-direction: row;
    }
`

const Titlecargo = styled.h3`
    display: inline-flex;
    font-size: 18px;
    font-weight: 300;
    grid-gap: 5px;
    & b {
        font-weight: 900;
    }

    @media (min-width: 996px) {
        font-size: 16px;
    }

    @media (min-width: 1280px) {
        font-size: 20px;
    }
`

const Single_exp = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    padding: 30px 0;
    margin-bottom: 20px;
    border-bottom: 1px solid;
    @media (min-width: 996px) {
        flex-direction: row;
        padding: 40px 0;
        justify-content: space-between;
    }
    &:last-child {
        border-bottom: 0px solid;
    }
`

function Home() {
    return (
      <main>
        <Helmet>
            <title>Gabriel Barbosa | Desenvolvedor Web Pleno</title>
            <meta name="description" content="Gabriel Barbosa, desenvolvedor web pleno em Guarulhos-SP. Front-end com React, JavaScript e PHP, integrações de APIs e pós em Offensive Cyber Security pela FIAP." />
            <meta property="og:title" content="Gabriel Barbosa | Desenvolvedor Web Pleno" />
            <meta property="og:description" content="Gabriel Barbosa, desenvolvedor web pleno em Guarulhos-SP. Front-end com React, JavaScript e PHP, integrações de APIs e pós em Offensive Cyber Security pela FIAP." />
        </Helmet>
        <Bannerao className="banner-com-video">
        <BgBanner />

        <div className='container'>
            <h1 className='visually-hidden'>Gabriel Barbosa – Desenvolvedor Web Pleno</h1>
            <div className='row justify-content-lg-center'>
                <div className='col-12 col-lg-9'>
                    <JsonWindow />
                </div>
            </div>
        </div>
        </Bannerao>
        <Sectionpd>
            <div className='container'>
                <div className='row'>
                    <div className='col-12 text-center'>
                        <Title className='mb-lg-5'>PROJETOS</Title>
                    </div>
                </div>
            </div>
            <CarroselClientes />
        </Sectionpd>
        <Sectionpd className='bfexp' style={{background: "white"}}>
            <div className="container">
                <div className="row">
                    <div className='col-12'>
                        <Title className="mb-lg-5 pb-lg-5" style={{color: "#000"}}>EXPERIÊNCIA</Title>
                        <div className='exp__work'>
                            <Single_exp>
                                <div className='cargo'>
                                    <Titlecargo><b>DESENVOLVEDOR</b> <span> //</span> PLENO</Titlecargo>
                                </div>
                                <div className='desc_work ps-0 ps-lg-2'>
                                    <p>Desenvolvimento de interfaces responsivas, Criação de Layouts no FIGMA, Criação de APIs, criação e gerenciamento de bancos de dados, deploy e testes.</p>
                                </div>
                                <div className='local__work d-flex flex-column'>
                                    <span><strong>Grupo ICOM</strong></span>
                                    <span>SET2025_Atualmente</span>
                                </div>
                            </Single_exp>
                            <Single_exp>
                                <div className='cargo'>
                                    <Titlecargo><b>DESENVOLVEDOR</b> <span> //</span> JR.</Titlecargo>
                                </div>
                                <div className='desc_work'>
                                    <p>Desenvolvimento de interfaces, integrações com APIs externas, criação e gerenciamento de bancos de dados, implementação de backups e estratégias de recuperação, monitoramento e análise de logs, suporte na configuração de servidores, configuração e gerenciamento de pipelines, criação e implementação de scripts de automação, deploy e testes.</p>
                                </div>
                                <div className='local__work d-flex flex-column'>
                                    <span><strong>CRT Comunicação</strong></span>
                                    <span>DEZ2023_MAI2025</span>
                                </div>
                            </Single_exp>
                            <Single_exp>
                                <div className='cargo'>
                                    <Titlecargo><b>DESENVOLVEDOR</b> <span> //</span> ASSISTENTE.</Titlecargo>
                                </div>
                                <div className='desc_work'>
                                    <p>Criação de sites, LPs e interfaces, configuração e manutenção de servidores de hospedagem, gerenciamento de backup, captura de dados para integração automática, manutenção de sites e plugins, suporte técnico, administração de plataformas de e-mail marketing, implementação de tags de segmentação para tráfego pago.</p>
                                </div>
                                <div className='local__work d-flex flex-column'>
                                    <span><strong>Agência Decsigner</strong></span>
                                    <span>FEV2021_SET2023</span>
                                </div>
                            </Single_exp>
                        </div>
                    </div>
                </div>
            </div>
        </Sectionpd>
        <Sectionpd>
            <div className='container'>
                <div className='row justify-content-lg-between'>
                    <div className='col-12 col-lg-6 align-content-lg-center'>
                        <div>
                            <Title>CONHECIMENTOS</Title>
                            <Paragrafo>Domínio em HTML, CSS, PHP, JavaScript, usando JQuery, React e Node.js, conhecimentos em Python, conhecimento sólido em MySQL e SQL para manipulação de dados, e experiência com Microsoft Azure para soluções em nuvem.</Paragrafo>
                        </div>
                    </div>
                    <div className='col-12 col-lg-5'>
                        <div className='carrosels__logos'>
                            <CarrosselMultiplo />
                        </div>
                    </div>
                </div>
            </div>
        </Sectionpd>
        <Sectionpd>
            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <Title>CERTIFICADOS</Title>
                        <div className='certificados__all mt-3 mt-lg-5'>
                            <div className='single_certificado'>
                                <Certificadosbtn href="https://drive.google.com/file/d/11BpwTJxJCtqfdvgMIcwcmMLZo7C6w_p4/view" target="_blank">
                                    <span>Fase 2 - Start Point</span> <span><b>FIAP</b></span>
                                </Certificadosbtn>
                                <Certificadosbtn href="https://drive.google.com/file/d/19KR9aJsulmkVXzbyiHnJ6aWIio0zOe2R/view?usp=sharing" target="_blank">
                                    <span>Fase 1 - Welcome To Cyber World</span> <span><b>FIAP</b></span>
                                </Certificadosbtn>
                                <Certificadosbtn href="https://drive.google.com/file/d/1sDtUKNEAmQuVhwXHIKQKgzhvT8zjmEBe/view?usp=drive_link" target="_blank">
                                    <span>ANÁLISE E DESENVOLVIMENTO DE SISTEMAS</span> <span><b>UNIVERSIDADE CRUZEIRO DO SUL</b></span>
                                </Certificadosbtn>
                                <Certificadosbtn href="#">
                                    <span>AI-900 -  Implantação de serviços de inteligência artificial em nuvem</span> <span><b>SENAI</b></span>
                                </Certificadosbtn>
                                <Certificadosbtn href="https://drive.google.com/file/d/1bpDO8DKBB9bOJkPt9oPRZwuDqiTxrbL-/view?usp=sharing" target="_blank">
                                    <span>SC-900 - Fundamentos de segurança em Nuvem</span> <span><b>SENAI</b></span>
                                </Certificadosbtn>
                                <Certificadosbtn href="#">
                                    <span>Power BI</span> <span><b>SENAI</b></span>
                                </Certificadosbtn>
                                <Certificadosbtn href="#">
                                    <span>Habilitação Profissional Técnica em Informática</span> <span><b>SENAC</b></span>
                                </Certificadosbtn>
                                <Certificadosbtn href="#">
                                    <span>Qualificação Profissional de Assistente de Desenvolvimento de Aplicativos Computacionais</span> <span><b>SENAC</b></span>
                                </Certificadosbtn>
                                <Certificadosbtn href="#">
                                    <span>Assistente de Suporte e Manutenção de Computadores</span> <span><b>SENAC</b></span>
                                </Certificadosbtn>
                                <Certificadosbtn href="https://origamid.com/certificate/2ac4d7ba" target="_blank">
                                    <span>IT Essentials</span> <span><b>CISCO NETWORKING ACADEMY</b></span>
                                </Certificadosbtn>
                                <Certificadosbtn href="https://origamid.com/certificate/2ac4d7ba" target='_blank'>
                                    <span>Wordpress como CMS</span> <span><b>ORIGAMID</b></span>
                                </Certificadosbtn>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Sectionpd>
      </main>
    );
  }
  
  export default Home;
  